import Axios from 'axios';
import { ApplicationContext } from '../../../framework/framework/shared/ApplicationContext';
import HotHits from '../hotHits/HotHits';
import HotItems from '../hotItems/HotItems';
import * as style from './style.css';
import Emitter from '../../../services/eventEmmiter/EventEmmiter';
import Recomended from '../recomended/Recomended';
import { EventTypes } from '../../../services/eventEmmiter/EventTypes';
import React = require('react');

interface IProps {
    controller: string;
    appCtx: ApplicationContext;
}

interface IState { }

export default class HomePage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
        };
    }

    axios = Axios;
    componentDidMount() {
        const treeUri = this.props.appCtx.buildUrl('catalog/TaxonomyTree');
        this.axios.get(treeUri)
            .then(response => Emitter.emit(EventTypes.TaxonomyTree, response.data))
            .catch(() => { });
    }

    render() {
        return (
            <>
                {/* <Helmet>
                    <title>apcprodent.pl - zaopatrzenie agro, najlepszy wybór, najlepsi dostawcy</title>
                    <meta name="description" content="Sprzedawaj i kupuj online na rynku agro. Oferty produktów, promocje, zapytania cenowe, kalkulacje." />
                </Helmet> */}
                <div id={'homeWrapper'} className={style.homeWrapper}>

                    <div className={style.home}>

                        <Recomended
                            appCtx={this.props.appCtx}
                            url={'Catalog/Recomended'}
                            title={'Polecamy'} />
                        <HotItems
                            appCtx={this.props.appCtx}
                            url={'Catalog/PromoItems'}
                            title={'Promocja'} />
                        <HotItems
                            appCtx={this.props.appCtx}
                            url={'Catalog/ReviewedItems'}
                            title={'Ostatnio oglądane'} />
                        <HotHits
                            appCtx={this.props.appCtx}
                            url={'Catalog/BestItems'}
                            title={'Bestsellery'}

                        />

                    </div>

                </div>
            </>);
    }
}
